export default "__VITE_ASSET__BnWwK0BJ__"